<div [style.background-image]="('url(' + headerUrl + ')')" class="d-flex flex-row-fluid w-100 header-wrapper"
     style="height: 400px; background-size: cover; background-position: left 27%; border-radius: .4rem">
  <div (click)="pickHeader()" *ngPermissions="permissionService.Permission.device_create"
       class="userPicEdit userPicEditFar cursor-pointer">
    <sb-icon class="icon-center" icon="edit"></sb-icon>
  </div>
  <div class="d-flex align-items-center text-center flex-column justify-content-center h-100 w-100">
    <sb-card classes="green-border">
      <div card-body>
        <div class="d-flex justify-content-center text-center">
          <div style="position: absolute;top: -67px;display: flex;">
            <div>
              <h2 class="font-weight-bolder" style="color: #fdfeff;text-shadow: 0 0 10px #000;">
                {{ 'lang.globals.device' | translate }}&nbsp;{{ device?.id }}
                <ng-container *ngIf="device?.identifier">
                  ({{ device?.identifier }})
                </ng-container>
              </h2>
            </div>
          </div>

          <div class="d-flex flex-row">
            <div class="d-flex align-items-center mr-2">
              {{ 'lang.globals.status' | translate }}
              &#58;
            </div>
            <div [device]="device" [tooltipPlacement]="'top'" class="mr-2 d-flex align-items-center"
                 sb-device-online-status-icon></div>
            <div [device]="device" [tooltipPlacement]="'top'" class="mr-2 d-flex align-items-center"
                 sb-device-online-status></div>
            <div *ngPermissions="permissionService.Permission.tag_list" class="d-flex flex-row">
              <sb-tags [dtoId]="device?.id" [dtoType]="tagService.TaggableDTO.Device"
                       [tags]="device?.tags"></sb-tags>
            </div>
          </div>
        </div>
      </div>
    </sb-card>
    <sb-card>
      <div card-body>
        <div class="d-flex justify-content-between text-start">
          <div class="d-flex flex-row">
            <ng-container *ngFor="let devstatus of status; last as last;">
              <div [ngClass]="!last ? 'border-dashed-right' : ''" class="d-flex align-items-center px-1">
                <button [ngClass]="devstatus?.value ? 'green-bg' : 'grey-bg'" class="btn white"
                        container="body" ngbTooltip="{{ 'lang.deviceDetails.' + devstatus.type | translate }}"
                        placement="top"
                        style="box-shadow: 0 2px 4px 0 rgba(90,141,238,.5)">
                  <sb-icon *ngIf="devstatus?.value" icon="success"></sb-icon>
                  <sb-icon *ngIf="!devstatus?.value" icon="error"></sb-icon>
                  {{ 'lang.deviceDetails.' + devstatus.type | translate }}
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </sb-card>
  </div>
</div>

<div class="px-0 px-sm-0 px-md-2 px-lg-4 px-xl-5 px-xxl-10 px-xxxl-10" style="margin-top: -100px">
  <div class="row">
    <div class="col-lg-12 col-xl-3">
      <sb-card>
        <div card-body>
          <ul class="nav-tabs nav sidenav">
            <li class="nav-item">
              <a [isLinkActive]="util.RoutingID.deviceDetailsOverview" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.deviceDetailsOverview"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="eye"></sb-icon>
                {{ 'nav.network.devices.details.overview' | translate }}
                </span></a>
            </li>
            <li class="nav-item">
              <a *ngPermissions="[permissionService.Permission.device_attributes_show]"
                 [isLinkActive]="util.RoutingID.deviceDetailsAttributes"
                 [sbRouterLinkActive]="'active'" [sbRouterLink]="util.RoutingID.deviceDetailsAttributes"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="attributes"></sb-icon>
                {{ 'nav.network.devices.details.attributes' | translate }}
                </span></a>
            </li>
            <li class="nav-item">
              <a *ngPermissions="[permissionService.Permission.ss_nm_reporting]"
                 [isLinkActive]="util.RoutingID.deviceDetailsActivity"
                 [sbRouterLinkActive]="'active'" [sbRouterLink]="util.RoutingID.deviceDetailsActivity"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="online"></sb-icon>
                {{ 'nav.network.devices.details.activity' | translate }}
                </span></a>
            </li>
            <li *ngPermissions="[permissionService.Permission.device_show]" class="nav-item">
              <a [isLinkActive]="util.RoutingID.deviceDetailsPlayouts" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.deviceDetailsPlayouts"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="pieChartStake"></sb-icon>
                {{ 'nav.network.devices.details.playouts' |translate }}
                </span></a>
            </li>
            <li *ngPermissions="[permissionService.Permission.device_export_playout]" class="nav-item">
              <a [isLinkActive]="util.RoutingID.deviceDetailsNetworkBookings" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.deviceDetailsNetworkBookings"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="bookings"></sb-icon>
                {{ 'lang.globals.playoutDescriptor' |translate }}
                </span></a>
            </li>
            <li class="nav-item" *ngPermissions="[permissionService.Permission.device_log]">
              <a [isLinkActive]="util.RoutingID.deviceDetailsLog" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.deviceDetailsLog"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="list"></sb-icon>
                {{ 'nav.network.devices.details.log' |translate }}
                </span></a>
            </li>
            <li class="nav-item">
              <a [isLinkActive]="util.RoutingID.deviceDetailsPositions" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.deviceDetailsPositions"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="locationStreet"></sb-icon>
                {{ 'nav.network.devices.details.positions' |translate }}
                </span></a>
            </li>
            <li class="nav-item">
              <a [isLinkActive]="util.RoutingID.deviceDetailsGeoStats" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.deviceDetailsGeoStats"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="location"></sb-icon>
                {{ 'nav.network.devices.details.geoStats' |translate }}
                </span></a>
            </li>
            <li class="nav-item" *ngPermissions="[permissionService.Permission.ss_nm_reporting]">
              <a [isLinkActive]="util.RoutingID.deviceDetailsNetworkAccess" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.deviceDetailsNetworkAccess"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="networkShare"></sb-icon>
                {{ 'nav.network.devices.details.networkAccess' |translate }}
                </span></a>
            </li>
            <li class="nav-item" *ngPermissions="[permissionService.Permission.ss_nm_reporting]">
              <a [isLinkActive]="util.RoutingID.deviceDetailsSetlist" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.deviceDetailsSetlist"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="motives"></sb-icon>
                {{ 'nav.network.devices.details.setlist' |translate }}
                </span></a>
            </li>
            <li class="nav-item" *ngPermissions="[permissionService.Permission.ss_nm_reporting]">
              <a [isLinkActive]="util.RoutingID.deviceDetailsPlaybackSchedule" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.deviceDetailsPlaybackSchedule"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="schedules"></sb-icon>
                {{ 'nav.network.devices.details.playbackSchedule' | translate }}
                </span></a>
            </li>
            <li class="nav-item" *ngPermissions="[permissionService.Permission.ss_nm_reporting]">
              <a [isLinkActive]="util.RoutingID.deviceDetailsContentShare" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.deviceDetailsContentShare"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="management"></sb-icon>
                {{ 'nav.campaigns.contentShare' | translate }}
                </span></a>
            </li>
            <li class="nav-item" *ngPermissions="[permissionService.Permission.ss_nm_reporting]">
              <a [isLinkActive]="util.RoutingID.deviceDetailsPlaylist" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.deviceDetailsPlaylist"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="bookingList"></sb-icon>
                {{ 'nav.network.devices.details.playlists' | translate }}
                </span></a>
            </li>
            <li class="nav-item">
              <a [isLinkActive]="util.RoutingID.deviceDetailsScreens" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.deviceDetailsScreens"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="screen"></sb-icon>
                {{ 'lang.globals.screens' |translate }}
                </span></a>
            </li>
            <!--
            <li *ngPermissions="[permissionService.Permission.attachment_list, permissionService.Permission.attachment_attach_to_device]"
                class="nav-item">
              <a [isLinkActive]="util.RoutingID.deviceDetailsAttachments" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.deviceDetailsAttachments"
                 class="nav-link"><span>
                  <sb-icon class="mr-3" icon="attachments"></sb-icon>
                {{ 'lang.globals.attachments' | translate }}
                </span></a>
            </li>
            -->
          </ul>
        </div>
      </sb-card>
    </div>
    <div class="col-lg-12 col-xl-9">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<ng-container *sbPageAction>
  <button
    (click)="showOptionsModal()"
    *ngIf="permissionService.hasPermissions([permissionService.Permission.device_show, permissionService.Permission.device_pool_edit, permissionService.Permission.device_location_edit, permissionService.Permission.device_properties_edit])"
    class="btn btn-primary">
    <sb-icon class="mr-2" icon="setting"></sb-icon>
    {{ 'lang.globals.options' | translate }}
  </button>
</ng-container>
